/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_length_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Length (nt)`)
};

const es_dnamw_length_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longitud (nt)`)
};

const de_dnamw_length_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länge (nt)`)
};

const nl_dnamw_length_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lengte (nt)`)
};

const fr_dnamw_length_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longueur (nt)`)
};

const it_dnamw_length_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunghezza (nt)`)
};

const pt_br2_dnamw_length_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimento (nt)`)
};

const pt_dnamw_length_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimento (nt)`)
};

const ja_dnamw_length_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長さ (nt)`)
};

const zh_dnamw_length_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长度（nt）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_length_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_length_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_length_label", locale)
	if (locale === "en") return en_dnamw_length_label(inputs)
	if (locale === "es") return es_dnamw_length_label(inputs)
	if (locale === "de") return de_dnamw_length_label(inputs)
	if (locale === "nl") return nl_dnamw_length_label(inputs)
	if (locale === "fr") return fr_dnamw_length_label(inputs)
	if (locale === "it") return it_dnamw_length_label(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_length_label(inputs)
	if (locale === "pt") return pt_dnamw_length_label(inputs)
	if (locale === "ja") return ja_dnamw_length_label(inputs)
	return zh_dnamw_length_label(inputs)
};